<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { config } from "@/common/settings/config";

import { breadcrumbSimple, svgIcon } from "@/common/components";

const { t } = useI18n();
const router = useRouter();

const menuList = computed(() =>
  config.menu.register.map((item) => ({
    ...item,
    label: t(item.label),
  })),
);

const breadcrumbList = computed(() => [
  {
    key: "register",
    label: t("common.labels.registrations"),
    url: "/register",
  },
]);

function changeMenu(menu: any) {
  if (menu.url && !menu.external) router.push(menu.url);
  if (menu.url && menu.external) window.open(menu.url, "_blank");
}
</script>

<template>
	<article class="register-page">
		<section class="page-header">
			<breadcrumb-simple
				:items="breadcrumbList"
				:show-home="true"
				url-home="/home"
				active="register"
			/>
		</section>

		<section class="list">
			<template v-for="menu in menuList" :key="menu.key">
				<button class="item" @click="changeMenu(menu)">
					<svgIcon :icon="menu.icon" size="4rem" />
					<span>{{ menu.label }}</span>
				</button>
			</template>
		</section>
	</article>
</template>

<style lang="scss" scoped>
.register-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .page-header {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: inherit;
    background: white;
    border-radius: 0.5rem;
    padding-inline: 1rem;
    padding-block: 0.5rem;
  }

  .list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(12rem, 1fr));
    // display: flex;
    // flex-wrap: wrap;
    gap: 1rem;

    .item {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      padding-block: 3.5rem;
      // width: 12.1rem;
      // min-width: 12.1rem;
      // height: 12.1rem;
      // min-height: 12.1rem;
      background: white;
      border-radius: 0.5rem;
      border: none;
      outline: none;

      &:hover {
        background: var(--primary);
        color: var(--primary-color);
      }

      span {
        font-size: 1.1rem;
      }
    }
  }
}
</style>
